package com.patronat.top.ui.molecules

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.theme.*
enum class UiStatusStyle {
    ACTIVE,
    INACTIVE
}

// Модель елемента
data class UiStatusItem<T>(
    val label: String,
    val style: UiStatusStyle,
    val value: T
)

@Composable
fun <T> StatusDropdown(
    items: List<UiStatusItem<T>>,
    selectedItem: UiStatusItem<T>,
    onItemSelected: (T) -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }

    Box(modifier = modifier) {

        val (bgColor, contentColor, borderColor) = when (selectedItem.style) {
            UiStatusStyle.ACTIVE -> Triple(
                StatusActiveBg,
                StatusActiveContent,
                StatusActiveBorder
            )
            UiStatusStyle.INACTIVE -> Triple(
                StatusInactiveBg,
                StatusInactiveContent,
                StatusInactiveBorder
            )
        }

        Row(
            modifier = Modifier
                .background(color = bgColor, shape = RoundedCornerShape(20.dp))
                .border(width = 1.dp, color = borderColor, shape = RoundedCornerShape(20.dp))
                .clickable { expanded = !expanded }
                .padding(horizontal = 16.dp, vertical = 8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            Text(
                text = selectedItem.label,
                color = contentColor,
                fontSize = 14.sp,
                fontWeight = FontWeight.Medium
            )
            Spacer(modifier = Modifier.width(4.dp))
            Icon(
                painter = if (expanded) AppIcons.ArrowUp else AppIcons.ArrowDown,
                contentDescription = null,
                tint = contentColor,
                modifier = Modifier.size(20.dp)
            )
        }


        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            modifier = Modifier.background(White)
        ) {
            items.forEach { item ->
                // Колір тексту в списку
                val itemTextColor = when (item.style) {
                    UiStatusStyle.ACTIVE -> StatusActiveContent
                    UiStatusStyle.INACTIVE -> StatusInactiveContent
                }

                DropdownMenuItem(
                    text = {
                        Text(
                            text = item.label,
                            color = itemTextColor,
                            fontWeight = FontWeight.Medium
                        )
                    },
                    onClick = {
                        onItemSelected(item.value)
                        expanded = false
                    }
                )
            }
        }
    }
}